import { useListBlocks } from 'api/blocksApi';
import { useMemo, useRef } from 'react';
import { PAGE_SIZE } from 'components/mediaLibrary/constants';
import { BlockSearchRequest, createBlockSearchRequest } from './blockSearch';

export default function useBlockParams(page: number, searchTerm: string, disabled: boolean = false) {
  const { request, searchError } = useMemo(() => {
    try {
      return {
        request: createBlockSearchRequest(searchTerm, page, PAGE_SIZE),
        searchError: null,
      };
    } catch (error) {
      return {
        request: null,
        searchError: error instanceof Error ? error : new Error('Invalid search query.'),
      };
    }
  }, [page, searchTerm]);

  // Keep the last valid request so the previous results stay visible while the query is invalid.
  // Updated during render (not in an effect) to avoid an extra render and refetch when the request changes.
  const lastValidRequest = useRef<BlockSearchRequest | null>(request);
  if (request) {
    lastValidRequest.current = request;
  }

  return {
    query: useListBlocks(lastValidRequest.current, disabled || !request),
    searchError,
  };
}
